import { render, staticRenderFns } from "./LeftSideSiteTwo.vue?vue&type=template&id=1a612930&scoped=true&"
import script from "./LeftSideSiteTwo.vue?vue&type=script&lang=js&"
export * from "./LeftSideSiteTwo.vue?vue&type=script&lang=js&"
import style0 from "./LeftSideSiteTwo.vue?vue&type=style&index=0&id=1a612930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a612930",
  null
  
)

component.options.__file = "LeftSideSiteTwo.vue"
export default component.exports